const findEntity = (entities, entityId) => entities.find(entity => entity.id === entityId);

export default findEntity;
